import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LogoutComponent } from "./auth/logout/logout.component";

const routes: Routes = [
    { path: 'report', loadChildren: './theme/pages/default/components/auto-technical-report/report.module#ReportModule' },
	{ path: 'atuo-report-detail', loadChildren: './theme/pages/default/components/atuo-report-detail/report.module#ReportModule' },
	{ path: 'login', loadChildren: './auth/auth.module#AuthModule' },
    { path: 'logout', component: LogoutComponent },
    { path: 'forgetpw', component: LogoutComponent },
    { path: '', redirectTo: 'index', pathMatch: 'full' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }